var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTourActive)?_c('div',{staticClass:"tour-guide"},[_c('div',{staticClass:"tour-overlay",on:{"click":_vm.nextStep}}),_c('div',{staticClass:"tour-popup",style:(_vm.popupStyle)},[_c('h2',[_vm._v(_vm._s(_vm.currentStep.title))]),_c('p',[_vm._v(_vm._s(_vm.currentStep.content))]),_c('button',{on:{"click":_vm.nextStep}},[_vm._v("Next")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }